<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Noticias {{ this.type == 'hidden' ? 'Inactivas' : '' || this.type == 'public' ? 'Públicas' : ''}}
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'news_new'})"
            >
              Crear nueva noticia
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="findOffers()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body pl-0">
      <v-layout row wrap fill-height>
        <template
          v-for="ne in news"
        >
          <v-flex
          :key="ne.id"
          xs12 lg4
        >
          <card-new :item="ne" @activate="deleteNew(ne.id)"></card-new>
        </v-flex>
        </template>

      </v-layout>
    </div>
  </div>
</template>

<script>

import cardNew from '../../../shared/NewItem.vue'

export default {
  props: ['type'],
  data(){
    return{
      news:[],
    }
  },
  components: {
    cardNew
  },
  methods:{
    deleteNew(id){
      console.log('id new', id)
      try {
        this.$http.delete('app/articles/destroy',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params: {
            id: id
          }
        })
        .then(function(response){
            this.findNewsTypeOrState();
        })
      } catch (e) {
        alert(e.message)
      }
    },
    shortDate(date){
      let new_date =  date.substring(0,date.indexOf('T'))
      return new_date
    },
    findNews(){
      try {
        this.$http.get('app/articles/'+this.type+'/show_by_state',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params: {
            company: this.getCompany().id
          }
        })
        .then(function(response){
          this.news = response.body.data
          console.log('####################### this.news #################### index ', this.news)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findNewsByType(){
      try {
        this.$http.get('app/articles/'+this.type+'/show_by_news_type',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
        })
        .then(function(response){
          this.news = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findNewsTypeOrState(){
      if (this.type === 'all' || this.type === 'public' || this.type === 'hidden'){
        this.findNews()
      }
      if (this.type === 'Normal' || this.type === 'Video' || this.type === 'Titular') {
        this.findNewsByType()
      }
    }

  },
  mounted(){
    this.findNewsTypeOrState();
  },
  watch: {
    $route(to, from) {
      this.findNewsTypeOrState();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/news/normal/Index.vue